
import i18n from '@/lang';
import PageHeader from '@/components/PageHeader.vue';
import PageFooter from '@/components/PageFooter.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    PageHeader,
    PageFooter
  }
})
export default class extends Vue {
  get lang() {
    return i18n.locale;
  }
}
